import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import {
	Link
} from 'react-router-dom'

export default function Header() {
	return (
		<AppBar position="static">
			<Toolbar>
				<Link to={'/'}>
					<img style={{height: '48px'}} src={'./logo.png'} alt={'logo'}/>
				</Link>
			</Toolbar>
		</AppBar>
	)
}